import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'

import * as tag from '../../../tag'

/** Renders date ranges with the shared date-only display format. */
@ngCore.Component({
  imports: [tag.Component],
  selector: 'atn-date-range-content',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /**
   * Value to transform into the {@link readableDateRangeSg} which is to be
   * displayed on the UI
   */
  public readonly valueSg = ngCore.input<
    | ents.core.common.value.Raw<ents.core.common.value.types.Intrinsic.DateRange>
    | undefined
  >(undefined, {
    alias: 'value',
  })

  /**
   * Formatted value to display in the template
   */
  public readonly readableDateRangeSg = ngCore.computed(
    (value = this.valueSg()) => {
      // If date is undefined, we say that it is from the beginning of time to
      // the end of time
      if (value === undefined) {
        return 'BOT - EOT'
      }

      // When the end boundary is exclusive (e.g. PG daterange [start, end)),
      // subtract 1 day so the displayed date reflects the last included day
      let end = value.end
      if (end !== undefined && !value.includesEnd) {
        end = new Date(end.getTime() - 86_400_000)
      }

      const formattedStart = value.start
        ? ents.core.display.date.format(value.start)
        : 'BOT'
      const formattedEnd = end ? ents.core.display.date.format(end) : 'EOT'

      return `${formattedStart ?? 'BOT'} - ${formattedEnd ?? 'EOT'}`
    },
  )
}
